import React, { Component } from "react";
import * as Icon from "react-feather";

import { RichTextView } from "../common/rich_text_editor";

class FaqAccordionItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoError: false,
        };
    }

    onVideoError = (e) => {
        console.error("Video error:", e.currentTarget.error);
        this.setState({ videoError: true });
    };

    getConfidenceLabel(confidence) {
        if (confidence >= 0.7) return { text: "High", className: "faq-confidence--high" };
        if (confidence >= 0.4) return { text: "Medium", className: "faq-confidence--medium" };
        return { text: "Low", className: "faq-confidence--low" };
    }

    render() {
        let { faq, searchResult, isExpanded, onToggle, query } = this.props;
        let { videoError } = this.state;

        let confidenceInfo = searchResult ? this.getConfidenceLabel(searchResult.confidence) : null;

        // Prefer the rich content if the author provided one (display layer).
        // Otherwise fall back to the searched snippet (which the backend returns
        // unformatted but full-length).
        const richContent = (searchResult && searchResult.content) || faq.content || null;
        const fallbackSnippet = searchResult && searchResult.snippet;
        const bestSpan = searchResult && searchResult.bestSpan;
        const images = (searchResult && searchResult.images) || faq.images || [];

        return (
            <div className={`faq-accordion ${isExpanded ? "faq-accordion--expanded" : ""}`}>
                <button
                    className="faq-accordion__header"
                    onClick={() => onToggle(faq.id)}
                    aria-expanded={isExpanded}
                >
                    <div className="faq-accordion__header-left">
                        <Icon.ChevronRight
                            size={18}
                            className={`faq-accordion__chevron ${isExpanded ? "faq-accordion__chevron--open" : ""}`}
                        />
                        <div className="faq-accordion__question-wrapper">
                            <span className="faq-accordion__question">{faq.question}</span>
                            {faq.category && (
                                <span className="faq-accordion__category">{faq.category}</span>
                            )}
                        </div>
                    </div>
                    <div className="faq-accordion__header-right">
                        {searchResult && (
                            <>
                                <span className={`faq-confidence ${confidenceInfo.className}`}>
                                    {confidenceInfo.text} ({Math.round(searchResult.score * 100)}%)
                                </span>
                            </>
                        )}

                    </div>
                </button>

                {isExpanded && (
                    <div className="faq-accordion__body">
                        {(richContent || fallbackSnippet) && (
                            <div className="faq-accordion__answer">
                                <div className="faq-accordion__answer-header">
                                    <Icon.Cpu size={14} className="faq-accordion__answer-icon" />
                                    <span className="faq-accordion__answer-label">Answer</span>
                                </div>
                                {richContent ? (
                                    <RichTextView
                                        html={richContent}
                                        query={query}
                                        bestSpan={bestSpan}
                                        className="faq-accordion__answer-body faq-accordion__answer-body--rich"
                                    />
                                ) : (
                                    <div className="faq-accordion__answer-body">
                                        {fallbackSnippet}
                                    </div>
                                )}
                            </div>
                        )}

                        {images && images.length > 0 && !richContent && (
                            <div className="faq-accordion__gallery">
                                {images.map((img, idx) => (
                                    <a
                                        key={idx}
                                        className="faq-accordion__gallery-item"
                                        href={img.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={img.url} alt={img.name || `Screenshot ${idx + 1}`} />
                                    </a>
                                ))}
                            </div>
                        )}

                        <div className="faq-accordion__video-container">
                            {faq.videoTitle && (
                                <h4 className="faq-accordion__video-title">{faq.videoTitle}</h4>
                            )}
                            {videoError ? (
                                <div className="faq-accordion__video-error">
                                    <Icon.AlertTriangle size={18} />
                                    <span>Video unavailable</span>
                                </div>
                            ) : (
                                <video
                                    className="faq-accordion__video"
                                    controls
                                    preload="metadata"
                                    onError={this.onVideoError}
                                >
                                    <source src={faq.videoUrl} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default FaqAccordionItem;
